/* src/app/modules/shared/components/questions-dialog/questions-dialog.component.scss */
::ng-deep .mat-slide-toggle-content {
  white-space: normal !important;
}
.mat-mdc-slide-toggle span {
  white-space: normal !important;
}
.mat-mdc-slide-toggle {
  padding: 20px;
  margin-top: 50px;
}
.mat-mdc-dialog-content {
  min-height: 400px;
}
.list-item-form {
  padding-top: 20px !important;
  padding-bottom: 10px !important;
}
.mat-mdc-list-item {
  margin-top: 15px !important;
}
/*# sourceMappingURL=questions-dialog.component.css.map */
